import { Spinner } from "../../assets/Spinner";

const sizeClass = new Map([
  ["lg", "  px-l  h-4xl   gap-10  text-lg-semibold"],
  ["md", " gap-4 h-2xl px-m text-m-semibold"],
  ["smd", "col-gap-xs h-28 px-sm text-xs-semibold-lh-16"],
  ["sm", " px-sm  h-xl  gap-4   text-xs-semibold"],
]);

const iconSizeClass = new Map([
  ["lg", "h-4xl w-4xl"],
  ["md", "h-2xl w-2xl "],
  ["smd", "w-28 h-28"],
  ["sm", " h-xl w-xl"],
]);

const radiusClass = new Map([
  ["pill", "rounded-pill"],
  ["circle", "rounded-circle"],
  ["default", "rounded-m "],
]);

const variantClass = new Map([
  ["primary", "button-primary"],
  ["warning", "button-warning"],
  ["transparent-outlined", "button-transparent-outlined"],
  ["white-outlined", "button-white-outlined"],
  ["white", "button-white"],
  ["transparent", "button-transparent"],
  ["brand", "button-brand"],
]);

const IconSize = new Map([
  [
    "lg",
    {
      h: 24,
      w: 24,
    },
  ],
  [
    "md",
    {
      h: 14,
      w: 14,
    },
  ],
  [
    "sm",
    {
      h: 14,
      w: 14,
    },
  ],
]);

export const CommonButton = ({
  size,
  variant,
  className,
  type = "button",
  onClick,
  children,
  LeadingIcon,
  TrailingIcon,
  disabled = false,
  rounded = "default",
  loading,
  color,
  minHeight=""
}) => {
  return (
    <button style={{minHeight: minHeight}}
      disabled={disabled}
      className={`all-unset ${className} text-nowrap pointer-cursor flex items-center ${
        (!LeadingIcon || !TrailingIcon) && "justify-center"
      }   ${variantClass.get(variant)} ${sizeClass.get(size)} ${radiusClass.get(
        rounded
      )}  ${disabled && "button-disabled"}`}
      onClick={onClick ? (e) => onClick(e) : undefined}
      type={type}
    >
      {loading ? (
        <Spinner height={IconSize.get(size).h} width={IconSize.get(size).w} />
      ) : (
        <>
          {LeadingIcon && LeadingIcon}

          <div style={{color:color&&color,marginBottom:"1px",textTransform:"capitalize"}}>{children}</div>

          {TrailingIcon && TrailingIcon}
        </>
      )}
    </button>
  );
};

export const ButtonIcon = ({
  size,
  variant,
  className,
  type = "button",
  onClick = () => {},
  icon,
  disabled = false,
  rounded = "default",
  loading,
  clickable = true,
}) => {
  return (
    <button
      disabled={disabled}
      className={`all-unset pointer-cursor flex justify-center items-center  ${variantClass.get(
        variant
      )} ${iconSizeClass.get(size)} ${radiusClass.get(rounded)} ${className} ${
        disabled && "button-disabled"
      } `}
      onClick={(e) => onClick(e)}
      type={type}
	    style={{cursor: clickable ? 'pointer' : 'default'}}
    >
      {loading ? (
        <Spinner height={IconSize.get(size).h} width={IconSize.get(size).w} />
      ) : (
       icon
      )}
    </button>
  );
};
